import React, { useEffect } from 'react'
import { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'
import { RequiredError } from '../../elem/reporting/shared/form/InputField'

const selectStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '2.5em',
        fontSize: '1rem',
        borderRadius: '4px',
        borderColor: 'hsl(0, 0%, 85%);',
    }),
    container: (provided) => ({
        ...provided,
        minHeight: '1em',
    }),
    valueContainer: (provided) => ({
        ...provided,
        minHeight: '1em',
        maxHeight: '2em',
        padding: '0 6px 10px 6px',
        paddindBottom: '0.75rem',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    clearIndicator: (provided) => ({
        ...provided,
        padding: '2px',
        marginTop: '2px',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '1px',
        marginTop: '2px',
        // width: '1.5em'
    }),
    option: (provided) => ({
        ...provided,
        fontSize: '1rem',
    }),
    singleValue: (provided) => ({
        ...provided,
        padding: '0',
    }),
}

const BaseSelect = (props) => {
    return (
        <Select
            menuPlacement="auto"
            menuPortalTarget={document.body}
            closeMenuOnScroll={(e) =>
                e.target &&
                e.target?.className &&
                !e.target?.className?.includes('reactSelect')
            }
            styles={selectStyles}
            placeholder={
                props && props.placeholder ? props.placeholder : 'Select...'
            }
            isClearable={true}
            {...props}
            className={`reactSelect ${props.className}`}
            classNamePrefix="reactSelect"
        />
    )
}

const formatValueAsOption = (value, options, optionAlias) => {
    if (value === null || value === undefined) {
        return ''
    }
    if (
        typeof value === 'object' &&
        Object.keys(value).includes('value') &&
        Object.keys(value).includes('label')
    ) {
        return value
    }
    
    return options.find((x) => x.value === value)
}

const ReportSelect = ({
    name,
    control,
    rules,
    onOptionChange,
    onClear,
    options,
    placeholder,
    disabled,
    value,
    optionAlias,
    errors,
    formatLabel,
    overrideOptionSelected,
    isClearable = true,
}) => {
    const defaultVal = useMemo(
        () => formatValueAsOption(value, options, optionAlias),
        [value, options, optionAlias]
    )
    return (
        <>
            <Controller
                as={(props) => {
                    return (
                        <BaseSelect
                            options={options}
                            isClearable={isClearable && !disabled}
                            placeholder={placeholder}
                            isDisabled={disabled}
                            formatOptionLabel={
                                formatLabel
                                    ? (option) =>
                                          option ? formatLabel(option) : ''
                                    : undefined
                            }
                            isOptionSelected={
                                overrideOptionSelected
                                    ? (option, selectValue) =>
                                          option
                                              ? overrideOptionSelected(
                                                    option,
                                                    selectValue
                                                )
                                              : ''
                                    : undefined
                            }
                            {...props}
                            value={formatValueAsOption(props.value, options)}
                        />
                    )
                }}
                name={name}
                control={control}
                rules={rules}
                defaultValue={defaultVal}
                onChange={([selectedValue]) => {
                    if (!selectedValue && onClear) {
                        onClear()
                    }
                    if (selectedValue && !!onOptionChange) {
                        onOptionChange(selectedValue.value, selectedValue)
                    }
                    return selectedValue
                }}
            />
            <RequiredError name={name} errors={errors} />
        </>
    )
}

export default ReportSelect
export { selectStyles, BaseSelect }
